import { render } from "./XlsxCell.vue?vue&type=template&id=5877f8c5&scoped=true"
import script from "./XlsxCell.vue?vue&type=script&lang=ts"
export * from "./XlsxCell.vue?vue&type=script&lang=ts"

import "./XlsxCell.vue?vue&type=style&index=0&id=5877f8c5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5877f8c5"

export default script